import React, { ReactElement } from 'react'
import { IModalActions } from '../../interfaces/Modal'
import { attention } from '../../assets/images/images'

function Logout({ onClose, onConfirm }: IModalActions): ReactElement {
  return (
    <div className="modalDialog modalLogout borderRadius0">
      <div className="textCenter">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <div className="modalHeader">
          <span onClick={onClose} className="modalClose" />
        </div>
        <div className="modalIcon">
          <img src={attention} alt="attention" />
        </div>
      </div>
      <div className="modalContent pb3">
        <h1 className="mb35 mt4 lh29 modalTitle">
          Vous êtes sur le point de vous déconnecter
        </h1>
        <p className="fontWeightBold mb35 textLeft">
          Sachez que vos informations sont sauvegardées à chaque nouvelle étape
          et que vous pourrez reprendre là où vous vous êtes arrêté.
        </p>
        <div className="dFlex justifyContentBetween flexWrap">
          <button
            onClick={onClose}
            className="btn btnOutline wFull wAutoSm mb15 mb0sm mr1sm"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  )
}

export default Logout
